import React, { useEffect, useState } from "react";
import "./Header.scss";
import { IoMdNotificationsOutline } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { RiLockPasswordLine } from "react-icons/ri";
import { useStateValue } from "../../StateProvider";
import { IoSettingsOutline } from "react-icons/io5";
import { MdLogout } from "react-icons/md";
import { useQuery } from "@tanstack/react-query";
import { getNotificationCount, logout } from "../../apiCall";
import { MdOutlineFileDownload } from "react-icons/md";
import toast from "react-hot-toast";

const Header = ({ toggle }) => {
  const [{ userInfo, isRefetchNotificationCount }, dispatch] = useStateValue();
  const [notificationCount, setNotificationCount] = useState(0);
  const navigate = useNavigate();
  const handleLogout = async () => {
    dispatch({ type: "SET_LOADING", status: true });

    try {
      let response;

      response = await logout();
      if (response?.status === 200) {
        localStorage.clear();
        dispatch({ type: "SET_USER_INFO", data: {} });
        dispatch({ type: "SET_LOGIN_STATUS", status: false });
        navigate("/sign-in");
        toast.success("Logged out successfully.");
      } else if (response?.response) {
        toast.error(response?.response?.data?.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    dispatch({ type: "SET_LOADING", status: false });
  };
  const fetchNotificationCount = async () => {
    // Perform the API call to fetch company info
    dispatch({ type: "SET_LOADING", status: true });

    try {
      let response;

      response = await getNotificationCount();

      if (response?.status === 200) {
        setNotificationCount(response?.data?.data ? response?.data?.data : 0);
        dispatch({ type: "REFETCH_NOTIFICATION_COUNT", status: false });
      } else if (response?.response?.status) {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    dispatch({ type: "SET_LOADING", status: false });
  };
  //  ***************************************************** pwa start *********************************
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if the app is already installed
    if (window.matchMedia("(display-mode: standalone)").matches) {
      setIsInstalled(true);
    }

    // Listen for the beforeinstallprompt event and store it
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault(); // Prevent the automatic prompt
      setDeferredPrompt(e); // Save the event so we can trigger it later
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    // Listen for the appinstalled event
    window.addEventListener("appinstalled", () => {
      console.log("PWA installed");
      setIsInstalled(true); // Hide the install button after installation
    });

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
      window.removeEventListener("appinstalled", () => setIsInstalled(true));
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // Show the install prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the PWA installation");
        } else {
          console.log("User dismissed the PWA installation");
        }
        setDeferredPrompt(null); // Clear the prompt as it's no longer needed
      });
    }
  };
  //  ***************************************************** pwa end *********************************
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["unread-notification-count"],
    queryFn: () => fetchNotificationCount(),
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  useEffect(() => {
    if (isRefetchNotificationCount) {
      refetch();
    }
  }, [isRefetchNotificationCount]);
  return (
    <div className="header">
      {/* navbar */}
      <div className="navbar-custom navbar navbar-expand-lg">
        <div className="container-fluid px-0">
          <div className="d-flex justify-content-center align-items-center">
            <div className="navbar-brand d-block ">
              <div className="header-logo">Task Trak</div>
            </div>
            <div
              id="nav-toggle"
              className="ms-auto ms-md-0 me-0 me-lg-3 "
              style={{ cursor: "pointer" }}
              onClick={() => toggle()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={28}
                height={28}
                fill="currentColor"
                className="bi bi-text-indent-left text-muted"
                viewBox="0 0 16 16"
              >
                <path d="M2 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm.646 2.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L4.293 8 2.646 6.354a.5.5 0 0 1 0-.708zM7 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm-5 3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" />
              </svg>
            </div>
          </div>
          <div className="d-none d-md-none d-lg-block"></div>
          {/*Navbar nav */}
          <ul className="navbar-nav navbar-right-wrap ms-lg-auto d-flex nav-top-wrap align-items-center ms-4 ms-lg-0">
            <li className="dropdown stopevent ms-2">
              <div
                className="btn btn-ghost btn-icon rounded-circle notification-icon"
                onClick={() => navigate(`notification?status=pending`)}
              >
                <IoMdNotificationsOutline size={28} />
                <div className="notification-count">{notificationCount}</div>
              </div>
            </li>
            {/* List */}
            <li className="dropdown ms-2">
              <div
                className="rounded-circle"
                // href="#!"
                role="button"
                id="dropdownUser"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div className="avatar avatar-md avatar-indicators avatar-online">
                  {userInfo?.user_profile_img ? (
                    <img
                      alt="avatar"
                      src={userInfo?.user_profile_img}
                      className="rounded-circle"
                    />
                  ) : (
                    <>
                      {userInfo?.user_gender === "Male" ? (
                        <img
                          alt="avatar"
                          src="./assets/images/avatar/male.jpg"
                          className="rounded-circle"
                        />
                      ) : (
                        <img
                          alt="avatar"
                          src="./assets/images/avatar/female.jpg"
                          className="rounded-circle"
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
              <div
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="dropdownUser"
              >
                <div className="px-4 pb-0 pt-2">
                  <div className="lh-1 ">
                    <h5 className="mb-1">{userInfo?.user_name}</h5>
                    {/* <a href="#!" className="text-inherit fs-6">
                        View my profile
                      </a> */}
                  </div>
                  <div className=" dropdown-divider mt-3 mb-2" />
                </div>
                <ul className="list-unstyled">
                  {userInfo.user_type === "SysAdm" && (
                    <li>
                      <Link
                        style={{ cursor: "pointer" }}
                        to={`/setting`}
                        className="dropdown-item d-flex flex-row"
                      >
                        {" "}
                        <div className="me-2">
                          <IoSettingsOutline size={20} />
                        </div>
                        Setting
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link
                      to={`/change-password?LoginId=${userInfo?.user_loginid}`}
                      className="dropdown-item  d-flex flex-row"
                    >
                      <div className="me-2">
                        <RiLockPasswordLine size={20} />
                      </div>
                      Change Password
                    </Link>
                  </li>
                  {!(isInstalled || !deferredPrompt) && (
                    <li>
                      <div
                        className="dropdown-item  d-flex flex-row cursor-pointer"
                        onClick={() => handleInstallClick()}
                      >
                        <div className="me-2">
                          <MdOutlineFileDownload size={20} />
                        </div>
                        Install App
                      </div>
                    </li>
                  )}

                  <li>
                    <div
                      className="dropdown-item d-flex flex-row "
                      style={{ cursor: "pointer" }}
                      onClick={() => handleLogout()}
                    >
                      <div className="me-2">
                        <MdLogout size={20} />
                      </div>
                      Sign Out
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Header;
